import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../../../libs/shared/ui/src/components/utility/skeleton';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Components.
 */

export const KeyMetricValue = styled.div`
  font-size: 32px;
  line-height: 38px;
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.greys.shade80};
  ${ellipsis()};
`;

export const KeyMetricValueSkeleton: FC = () => <Skeleton height="38px" />;
